<mat-tab-group>
  <!-- Deals -->
  <mat-tab label="Deals">
    <div class="flex justify-center mt-10 mb-2">
        <div class="grid lg:grid-cols-4 gap-4 w-[90%]">
            <mat-card *ngFor="let deal of deals">
                <mat-card-header>
                    <mat-card-title class="w-full">
                        {{ deal.title }}
                    </mat-card-title>

                    <mat-card-subtitle
                    *ngIf="deal.startDate && deal.expireDate"
                    class="flex"
                    >
                        Starts {{ deal.startDate | date : "M/d/yyyy, h:mm a" }}
                        | Expires {{ deal.expireDate | date : "M/d/yyyy, h:mm a" }}
                    </mat-card-subtitle>

                    <mat-card-subtitle *ngIf="!deal.startDate && deal.expireDate">
                        Expires {{ deal.expireDate | date : "M/d/yyyy, h:mm a" }}
                    </mat-card-subtitle>

                    <mat-card-subtitle
                    *ngIf="deal.startDate && !deal.expireDate"
                    class="flex"
                    >
                        Starts
                        {{ deal.startDate | date : "M/d/yyyy, h:mm a" }}
                    </mat-card-subtitle>

                    <mat-card-subtitle>
                        {{ deal.vendorName }}
                    </mat-card-subtitle>
                </mat-card-header>

                <div class="w-full flex justify-center h-3/4">
                    <img [src]="deal.image?.[0]?.url" />
                </div>

                <mat-card-content>
                    {{ deal.description }}
                    <div
                    *ngIf="deal.campusDeals?.length != 0"
                    class="flex flex-row flex-wrap"
                    >
                        <div>Campuses:</div>
                        <div class="mx-1" *ngFor="let campusDeal of deal.campusDeals">
                            <div>
                                {{ campusDeal.campus?.name }} -
                                {{ campusDeal.campus?.college?.name }}
                            </div>
                        </div>
                    </div>
                    <mat-slide-toggle [checked]="deal.status == 'ACTIVE'" (click)="toggleDealStatus(deal)">
                      Active
                    </mat-slide-toggle>
                </mat-card-content>

                <mat-card-actions class="justify-between">
                    <a
                    mat-raised-button
                    href="{{ deal.url }}"
                    *ngIf="deal.url !== '' && deal.url !== null"
                    >
                        Visit Website
                    </a>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="h-screen" *ngIf="this.deals?.length === 0">
        <div class="h-3/4 content-center">
            <mat-icon class="deal-icon">attach_money </mat-icon>

            <h2 class="no-deals-header">No deals available.</h2>

            <h2 class="no-deals-header">
                Start by creating a new deal to get started!
            </h2>
        </div>
    </div>
  </mat-tab>

  <!-- Housing -->
  <mat-tab label="Housing">
    <div class="flex justify-center mt-10 mb-2">
      <div class="grid lg:grid-cols-4 gap-4 w-[90%]">
            <mat-card *ngFor="let housing of apartmentsAndHousing">
              <mat-card-header>
                <mat-card-title class="w-full">
                  {{ housing.housingType | titlecase }}
                </mat-card-title>
              </mat-card-header>

              <mat-card-content>
                <div class="flex flex-row justify-between">
                  <div>${{ housing.amount }}</div>
                  <div>
                    {{ housing.paymentType | titlecase }}
                  </div>
                </div>

                <div class="text-pretty [overflow-wrap:anywhere]">
                  {{ housing.description }}
                </div>

                <div class="flex flex-row justify-between">
                  <div>
                    {{ housing.listingAgent }}
                  </div>
                  <div>Bedrooms: {{ housing.bedrooms }}</div>
                </div>

                <div class="flex flex-row justify-between">
                  <div>
                    {{ housing.street }}, {{ housing.city }} {{ housing.state }},
                    {{ housing.zipCode }}
                  </div>
                  <div></div>
                </div>

                <div
                  *ngIf="housing.campusDeals?.length != 0"
                  class="flex flex-row flex-wrap"
                >
                  <div>Campuses:</div>
                  <div class="mx-1" *ngFor="let campusDeal of housing.campusDeals">
                    <div>
                      {{ campusDeal.campus?.name }}
                      {{ campusDeal.campus?.college?.name }}
                    </div>
                  </div>
                </div>
                <mat-slide-toggle [checked]="housing.status == 'ACTIVE'" (click)="toggleDealStatus(housing)">
                  Active
                </mat-slide-toggle>
              </mat-card-content>
              <mat-card-actions class="justify-between">
                <a
                  mat-raised-button
                  href="{{ housing.url }}"
                  *ngIf="housing.url != null"
                >
                  Visit Website
                </a>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
        <div class="w-full h-3/4 content-center" *ngIf="this.apartmentsAndHousing.length === 0">
          <div class="flex flex-col">
            <mat-icon class="housing-icon"> home </mat-icon>
            <h2 class="no-housing-header">
              No apartments or housing listings available.
            </h2>
            <h2 class="no-housing-header">
              Start by creating a new apartment or housing listing to get started!
            </h2>
          </div>
        </div>
      </mat-tab>

  <!-- Jobs -->
  <mat-tab label="Jobs">
    <div class="flex justify-center mt-10 mb-2">
      <div class="grid lg:grid-cols-4 gap-4 w-[90%]">
        <mat-card *ngFor="let job of jobsAndInternships">
          <mat-card-header>
            <mat-card-title class="w-full">
              {{ job.businessName }}
            </mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <div class="flex flex-row justify-between">
              <div>
                {{ job.employmentType | titlecase }}
              </div>
              <div>
                {{ job.payType | titlecase }}
              </div>
            </div>

            <div class="flex flex-row justify-between">
              <div>{{ job.title }}</div>
              <div>${{ job.amount }}</div>
            </div>

            <div class="text-pretty [overflow-wrap:anywhere]">
              {{ job.description }}
            </div>

            <div class="flex flex-row justify-between">
              <div>
                {{ job.street }}, {{ job.city }} {{ job.state }},
                {{ job.zipCode }}
              </div>
              <div></div>
            </div>

            <div
              *ngIf="job.campusDeals?.length != 0"
              class="flex flex-row flex-wrap"
            >
              <div>Campuses:</div>
              <div class="mx-1" *ngFor="let campusDeal of job.campusDeals">
                <div>
                  {{ campusDeal.campus?.name }}
                  {{ campusDeal.campus?.college?.name }}
                </div>
              </div>
            </div>
            <mat-slide-toggle [checked]="job.status == 'ACTIVE'" (click)="toggleDealStatus(job)">
              Active
            </mat-slide-toggle>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="w-full h-3/4 content-center" *ngIf="this.jobsAndInternships.length === 0">
      <div class="flex flex-col">
        <mat-icon class="jobs-icon"> work_outline </mat-icon>
        <h2 class="no-jobs-header">No jobs or internships available.</h2>
        <h2 class="no-jobs-header">
          Start by creating a new job or internship opportunity to get started!
        </h2>
      </div>
    </div>
  </mat-tab>

  <!-- Posts -->
  <mat-tab label="Posts">
    <div class="flex justify-center mt-10 mb-2">
      <div class="grid lg:grid-cols-4 gap-4 w-[90%]">
        <mat-card *ngFor="let post of posts" class="m-2">
          <mat-card-header>
            <mat-card-title
              >{{ post.createdBy.firstName }}
              {{ post.createdBy.lastName }}</mat-card-title
            >
          </mat-card-header>
          <div>
            <img [src]="post.attachmentURL" class="max-h-36 m-3" />
          </div>

          <mat-card-content> 
            <div>{{ post.body }}</div>
            <mat-slide-toggle [checked]="post.status == 'ACTIVE'" (click)="togglePostStatus(post)">
              Active
            </mat-slide-toggle>
          </mat-card-content>
          <mat-card-actions>
            <button mat-stroked-button (click)="viewComments(post.id)" color="accent">
              Comments ({{ post.comments.length }})
            </button>
          </mat-card-actions>

          <div
            *ngIf="showComments && post.id === this.commentSectionPostId"
            class="m-2"
          >
            <mat-card *ngFor="let comment of post.comments" class="mt-2">
              <mat-card-header>
                <mat-card-subtitle
                  >{{ comment.createdBy.firstName }} {{ comment.createdBy.lastName }}
                </mat-card-subtitle>
              </mat-card-header>

              <div><img [src]="comment.attachmentURL" class="max-h-36 m-3" /></div>

              <mat-card-content> {{ comment.body }} </mat-card-content>
            </mat-card>
          </div>
        </mat-card>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>